import { makeStyles } from "@material-ui/core";

export const myPrivacyPolicyStyle = makeStyles((theme) => ({
  paper: {
    padding: "35px 55px",
    borderRadius: "12px",
    color: "#53CD94",
    fontSize: "25px",
    fontWeight: "bold",
    boxShadow: "none",
    width: "100%",
    marginBottom: "30px",
    overflow: "auto", 
    background:"white",
    [theme.breakpoints.down("sm")]: {
      padding: "25px",
    },
  },
  container:{
    display:"flex",
    "& p":{
      color:"#808285",
      fontSize:"12px",
      fontWeight:100,
    },
  },
  pageTitle: {
    color: "#333333",
    fontSize: "32px",
    fontWeight: 500,
    lineHeight: "38px",
    alignItems: "baseline",
    flexGrow: 1,
    [theme.breakpoints.down("sm")]: {
      fontSize: "25px",
    },
  },
  subTitulos:{
    color: "#333333",
    fontSize: "25px",
    fontWeight: 500,
    lineHeight: "38px",
    alignItems: "baseline",
    flexGrow: 2,
    [theme.breakpoints.down("sm")]: {
      fontSize: "20px",
    },
  },
  container2:{
    paddingTop:"20px",
    "& p":{
      color:"black",
      fontSize:"14px",
      fontWeight:100,
      textAlign:"justify",
    }
  },
  lista:{
    "& li":{
      color:"black",
      fontSize:"14px",
      fontWeight:100,
    }
  }
}))